import React from 'react';
import { WebsitesHero } from '../components/websites/WebsitesHero';
import { ProofStrip } from '../components/websites/ProofStrip';
import { OldVsLiving } from '../components/websites/OldVsLiving';
import { HowItWorks } from '../components/websites/HowItWorks';
import { ChangeChannels } from '../components/websites/ChangeChannels';
import { WhatsIncluded } from '../components/websites/WhatsIncluded';
import { WebsiteFeatures } from '../components/websites/WebsiteFeatures';
import { FullSystem } from '../components/websites/FullSystem';
import { FeelAlive } from '../components/websites/FeelAlive';
import { ThreeDayBuild } from '../components/websites/ThreeDayBuild';
import { RealSites } from '../components/websites/RealSites';
import { TryItNow } from '../components/websites/TryItNow';
import { TwoWaysToStart } from '../components/websites/TwoWaysToStart';
import { ComingSoon } from '../components/websites/ComingSoon';
import { WebsitesFinalCta } from '../components/websites/WebsitesFinalCta';
import { ExploreMore } from '../components/websites/ExploreMore';
import { ServiceFaq } from '../components/ServiceFaq';
import { websitesPageFaqs } from '../data/faqs';
export function Websites() {
  return <>
      <WebsitesHero data-id="element-1060" data-mp="2iekw9k8ehrog" />
      <ProofStrip data-id="element-1061" data-mp="2if313594pe7z" />
      <OldVsLiving data-id="element-1062" data-mp="2ihp6ozcgljnk" />
      <HowItWorks data-id="element-1063" data-mp="2mh7rzw86zwqx" />
      <ChangeChannels data-id="element-1064" data-mp="2mgojf64fmkpk" />
      <WhatsIncluded data-id="element-1065" data-mp="2mfwolxinsr0c" />
      <WebsiteFeatures data-id="element-1066" data-mp="2mfemik9bfiki" />
      <FullSystem data-id="element-1067" data-mp="28pt8loadhtjc" />
      <FeelAlive data-id="element-1068" data-mp="28pb5c7pamf1x" />
      <ThreeDayBuild data-id="element-1069" data-mp="28orx5ipg3513" />
      <RealSites data-id="element-1070" data-mp="28o8h67jcuqpp" />
      <TryItNow data-id="element-1071" data-mp="28nqaegz2gu3j" />
      <TwoWaysToStart data-id="element-1072" data-mp="2dgjer3qmi0f3" />
      <ComingSoon data-id="element-1073" data-mp="2dgt5wunemdmd" />
      <ServiceFaq serviceName="Living Websites" faqs={websitesPageFaqs} showContact={false} data-id="element-1074" data-mp="2dhbbihvyi46y" />
      <WebsitesFinalCta data-id="element-1075" data-mp="1ysok3ht21lzd" />
      <ExploreMore data-id="element-1076" data-mp="1ytgfosmnjjpn" />
    </>;
}